export const CREATE_TWILIO_TOKEN = 'CREATE_TWILIO_TOKEN'
export const CREATE_TWILIO_DEVICE = 'CREATE_TWILIO_DEVICE'
export const CREATE_SOCKET_CONNECTION = 'CREATE_SOCKET_CONNECTION'
export const INCOMING_CALL = 'INCOMING_CALL'
export const ACCEPT_INCOMING_CALL = 'ACCEPT_INCOMING_CALL'
export const END_INCOMING_CALL = 'END_INCOMING_CALL'